

export default () => ({
    cabecera                : false,
    datos                   : null,
    loadingGlobal           : true,
    mostrarInput            : false,
    verMensajes             : false,
    reclamoAutomatico       : false,
    dataVtex                : null,
    selectedProduct         : false,
    plazoEntrega            : null,
    enTiempo                : null,
    enFarmaciaHasta         : null,
    dias30                  : null,
    arrepentido             : false,
    fechaEntrega            : null,
    estadoCaso              : null,
    pedidoCancelado         : false,
    numeroCaso              : 0,
    mostrarChat             : null,  
    textoCancelandoPedido   : 'Enviando solicitud, espere por favor...',
    messages                : [],
    
})